import React from 'react';
import { faAngleLeft, faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppBar, Toolbar, IconButton, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { updateMobileView } from '../../../actions/mobileActions';
import { getFormattedPaycodeDuration, } from '../../Calendar/calendarFunctions';
import { DAILY } from '../constants';
import { getPaycodeTimePeriod } from '../../Utils/uiGenerators';
import { styles } from './paycodeSidePanel.service';


const PaycodeSidePanel = () => {
    const dispatch = useDispatch();
    const goToDailyView = () => dispatch(updateMobileView(DAILY));
    const { paycode } = useSelector((state) => state.mobilePaycodeForm);

    const {
        durationInTime, payCodeRef: { qualifier }, assignmentName,
    } = paycode;

    const formattedDuration = getFormattedPaycodeDuration(durationInTime);
    const title = `${qualifier} [${formattedDuration}]`;
    const timeRange = getPaycodeTimePeriod(paycode);

    return (
        <>
            <AppBar position="relative" style={styles.appBar}>
                <Toolbar>
                    <Grid
                        container
                        alignItems={'center'}
                    >
                        <Grid item xs={2}>
                            <IconButton onClick={goToDailyView} size="large">
                                <FontAwesomeIcon
                                    icon={faAngleLeft}
                                    style={styles.backButton}
                                />
                            </IconButton>
                        </Grid>
                        <Grid item xs={8}>
                            <div style={styles.title}>{title}</div>
                        </Grid>
                        <Grid item xs={2} style={styles.closeButtonWrapper}>
                            <IconButton onClick={goToDailyView} size="large">
                                <FontAwesomeIcon icon={faTimes} style={styles.closeButton} />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <div style={styles.contentWrapper}>
                {assignmentName && (
                    <div style={styles.content}>Assignment: {assignmentName}</div>
                )}
                <div style={styles.content}>{timeRange}</div>
            </div>
        </>
    );
};

export default PaycodeSidePanel;
